// Entry

// Default
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { setupErrorHandlers } from "./utils/errorHandlers";

// Styles
import "./styles/_index.scss";
import "./styles/index.css";
import theme from "./theme";

// Report & Analytics scoped styles
import "./features/reportAnalytics/reportAnalytics.css";

// Mui
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Context
import CustomFieldsProvider from "./context/CustomFieldsProvider";

//redux
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/es/integration/react";

//react-query
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

// Initialize error handlers to suppress benign ResizeObserver errors
setupErrorHandlers();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <ThemeProvider theme={theme}>
            <CustomFieldsProvider>
              <CssBaseline />
              <App />
            </CustomFieldsProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </Router>
  </QueryClientProvider>,
);

reportWebVitals();
